import { useUserApiMutation } from "src/lib/filmwebid/useUserApiMutation";
import { useCallback, useState } from "react";
import type { IFilmwebIdMovieIdentifier } from "src/lib/filmwebid/useMovieIdentifier";

type UseRatingProps = {
	movieIdentifier: IFilmwebIdMovieIdentifier | null | undefined;
	onComplete?: () => void;
	initialValue?: number;
}

export default function useRating({ movieIdentifier, initialValue, onComplete }: UseRatingProps):
	[doRating: (ratingValue: number | undefined) => void, isWorking: boolean, rating: number | undefined, isDone: boolean] {

	const [rating, setRating] = useState(initialValue);

	const { mutate, isPending, isSuccess } = useUserApiMutation("/api/Ratings", { allowAnon: false }, {
		onSuccess: onComplete,
	});

	const doRating = useCallback((ratingValue: number | undefined) => {
		if ((ratingValue ?? -1) >= 0) {
			setRating(ratingValue);
			mutate({
				method: "POST",
				body: {
					movieIdentifier,
					source: window?.location?.hostname,
					rating: ratingValue
				}
			});
		} else {
			setRating(undefined);
			mutate({
				method: "DELETE",
				params: movieIdentifier ? { [movieIdentifier.type]: movieIdentifier.value } : {}
			});
		}
	}, [movieIdentifier, mutate]);

	return [doRating, isPending, rating, isSuccess];
}
